import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { homeRoutes } from "@/util/constant/RouteConstant.ts";
import { Button } from "@/components/ui";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { svgLinks } from "../../../../public/assets/assetLinks";

export const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  function gotoGetStarted() {
    window.open("https://app.qoonity.com/auth/register", "_blank");
  }
  function gotoLogin() {
    window.open("https://app.qoonity.com/auth/login", "_blank");
  }
  return (
    <div className="text-[#ffffff60]">
      <div className="justify-between px-20 py-10 items-center hidden lg:flex flex-row">
        <div className="flex flex-row items-center gap-10">
          <button onClick={() => navigate("/home")}>
            <img src={svgLinks.logo} alt="Logo" />
          </button>
          <div className="flex flex-row text-lg gap-10">
            {homeRoutes.navRoutes.slice(0, 4).map((route, index) => (
              <a
                href={`#${route.id}`}
                key={index}
                className="hover:text-white cursor-pointer"
              >
                {route.name}
              </a>
            ))}
          </div>
        </div>
        <div className="flex-row flex items-center gap-10">
          <h1
            onClick={() => gotoLogin()}
            className="cursor-pointer hover:text-white"
          >
            {homeRoutes.auth.login.name}
          </h1>
          <Button
            label="Sign up"
            state="tertiary"
            onClick={() => gotoGetStarted()}
          />
        </div>
      </div>

      <div className="justify-between px-5 pt-10 items-center flex lg:hidden flex-row">
        <div className="flex flex-row items-center gap-10">
          <img src={svgLinks.logo} alt="Logo" />
        </div>
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          aria-label="Toggle menu"
        >
          {isOpen ? (
            <MdClose color="white" size={24} />
          ) : (
            <FiMenu color="white" size={24} />
          )}
        </button>
      </div>

      {isOpen && (
        <div className="bg-[#0C0D0D] p-5 absolute shadow-xl w-full z-10 transition-all duration-300">
          <div className="flex flex-col text-lg gap-3 mb-3">
            {homeRoutes.navRoutes.slice(0, 4).map((route, index) => (
              <a key={index} href={`#${route.id}`}>
                <h2 className="hover:text-white  text-white cursor-pointer">
                  {route.name}
                </h2>
              </a>
            ))}
          </div>
          <div className="flex-col flex gap-6">
            <h2
              onClick={() => gotoLogin()}
              className="cursor-pointer text-[16px] text-white hover:text-white"
            >
              {homeRoutes.auth.login.name}
            </h2>

            <Button
              label="Sign up"
              state="tertiary"
              className="w-full"
              onClick={() => gotoGetStarted()}
            />
          </div>
        </div>
      )}
    </div>
  );
};
